<template>
  <div>
    <v-card>
      <v-container grid-list-lg>
        <v-layout class="ma-2" align-center="align-center" justify-center row>
          <div class="text-center">
            <h1 class="font-weight-light display-3">Repair Store</h1>
            <h1 class="headline">Now that we have you onboard with us</h1>
            <div class="text-center mt-3 font-weight-medium">
              <div>Did you know the repair industry made</div>
              <div>
                <span class="display-2 font-weight-black red--text">$4 BILLION </span>
                <span class="font-weight-medium">last year?</span>
              </div>
              <div>Join the trend or keep track of your repair service.</div>
              <div class="mt-2 font-weight-medium">
                Below are the key features of the Repair module, click any feature to view details:
              </div>
            </div>
          </div>
        </v-layout>
        <v-layout class="mt-3" row wrap>
          <v-flex xs12 sm4="sm4" md3="md3" v-for="item in items">
            <v-tooltip top="top">
              <div slot="activator" :active-click="true" width="100%" height="200px">
                <div class="text-center" slot="front">
                  <v-container>
                    <img :src="item.img" width="60" />
                    <h3 class="h3-header">{{ item.title }}</h3>
                  </v-container>
                </div>
                <div slot="back">
                  <v-card dark="dark">
                    <v-container>
                      <div class="text-center">
                        <img :src="item.img" width="60" />
                        <div>{{ item.detail }}</div>
                      </div>
                    </v-container>
                  </v-card>
                </div>
              </div>
              <span>Click for detail</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
        <v-divider> </v-divider>
        <v-card-actions class="mt-3">
          <v-layout row wrap>
            <v-layout column>
              <h2 class="h2-header">All that for Only {{ price | currency }} a month</h2>
              <div>added to your monthly plan</div>
            </v-layout>
            <v-spacer> </v-spacer>
            <v-btn color="blue darken-1" large text @click="removeDeal">{{
              $t("buttons.noThanks")
            }}</v-btn>
            <v-btn color="blue darken-1" large dark="dark" @click="save">{{
              $t("buttons.addFeature")
            }}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      showQuestion: true,
      price: 20,
      name: "Repair",
      items: [
        {
          img: require("../../../../assets/upSale/bill.png"),
          title: "Create Ticket",
          detail: "Keep track of every repairs & IMEI number alng with customers information."
        },
        {
          img: require("../../../../assets/upSale/checklist.png"),
          title: "Ticket List",
          detail:
            "View a list of repair tickets with customer information, employoee name, price and the notes taken during the repair."
        },
        {
          img: require("../../../../assets/upSale/email.png"),
          title: "Text Message",
          detail:
            "Send text messages to customers when the repair job is finished or if it’s irreparable. "
        },
        {
          img: require("../../../../assets/upSale/signature.png"),
          title: "Signature Capture",
          detail:
            "The Repair System allows you to capture a customers signature before and after the repair has been picked up or delivered."
        },
        {
          img: require("../../../../assets/upSale/calendar.png"),
          title: "Reminder",
          detail:
            "The reminder allows employees to keep track of which phones have been sitting on the shelf for more than X amount of days."
        },
        {
          img: require("../../../../assets/upSale/policy.png"),
          title: "Custom Policy",
          detail:
            "Create your own individual repair policy that can be different from that of the sales or bill payments policy."
        },
        {
          img: require("../../../../assets/upSale/invoice.png"),
          title: "Receipt",
          detail:
            "Print professional looking receipts designed specifically for wireless repair store"
        },
        {
          img: require("../../../../assets/upSale/payment-method.png"),
          title: "Payment Installment",
          detail:
            "Not every customer can pay for a repair job all at once, now you can collect the payments in installments."
        },
        {
          img: require("../../../../assets/upSale/keypad.png"),
          title: "Android Pattern",
          detail:
            "Capture the password or android pattern of the repair device at the time of creating the receipt."
        },
        {
          img: require("../../../../assets/upSale/assignment.png"),
          title: "Assigned Tickets",
          detail: "Assign tickets to a specific repair technician"
        },
        {
          img: require("../../../../assets/upSale/test.png"),
          title: "Price List",
          detail:
            "Create a list that shows the exact price pre phone per damage. That way employee can easlly and quickly provide the customer with the appropriate price"
        },
        {
          img: require("../../../../assets/upSale/report.png"),
          title: "Reports",
          detail: "View multiple reports for every type of repair job."
        },
        {
          img: require("../../../../assets/upSale/placeholder.png"),
          title: "Bin Location",
          detail:
            "Assign locations to every phone. if the technician who did the job is not in that store anyone is able to find the phone easlly."
        },
        {
          img: require("../../../../assets/upSale/smartphone.png"),
          title: "Loaner Phone",
          detail:
            "Give your customer a loaner phone without any issues. System will remind you to take back before closing the repair."
        },
        {
          img: require("../../../../assets/upSale/more.png"),
          title: "And More",
          detail: "And much more Sign up and see for youself."
        }
      ]
    };
  },
  methods: {
    ...mapActions("location", ["feature", "removeDeal"]),
    save() {
      this.feature({
        id: 4,
        feature: this.name,
        price: this.price
      });
    }
  }
};
</script>

<style scoped></style>
